import type { IApplicationState } from 'shared/types/redux';
import { IDeveloperAwardsForCardSchema } from 'shared/repositories/special-promos/entities/developer_awards_for_card/DeveloperAwardsForCardSchema';

export function developerAwardsSelector(state: IApplicationState): IDeveloperAwardsForCardSchema | null {
  return state.specialPromosBlocks.developerAwards;
}
